export class RecordListVariables {
    private _scrollObserver!: IntersectionObserver | null; // Handle scroll to lazy load next date block.

    constructor() { }

    get scrollObserver(): IntersectionObserver | null {
        return this._scrollObserver;
    }

    set scrollObserver(value: IntersectionObserver | null) {
        this._scrollObserver = value;
    }
}
